import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Retry once on transient errors, but NEVER retry a 15s timeout (err.timeout)
      // so a stalled request surfaces the error + Retry UI immediately instead of
      // spinning through another full timeout window. See lib/api.js (CRITICAL timeout).
      retry: (count, err) => !err?.timeout && count < 1,
      // Serve cached data instantly, then refresh in the background (SWR).
      staleTime: 30_000,
      // Keep cached responses around for the whole session so revisiting a
      // screen renders from cache immediately instead of refetching cold.
      gcTime: 24 * 60 * 60 * 1000,
    },
  },
});
